import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
//6.引入导出的路由
import router from './router/index'
import "./assets/common.css";

Vue.config.productionTip = false;
//2.使用路由
Vue.use(VueRouter);

new Vue({
  //7.注册路由
  router,
  render: h => h(App),
}).$mount('#app')
